
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 76 76"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('style',[_v('.b{fill:#454545;}')])]),_c('polygon',{staticClass:"b",attrs:{"points":"75.27 30.98 45.02 30.98 45.02 .73 30.98 .73 30.98 30.98 .73 30.98 .73 45.02 30.98 45.02 30.98 75.27 45.02 75.27 45.02 45.02 75.27 45.02 75.27 30.98"}})])
          )
        }
      }
    